<template>
  <div class="px-3" v-if="me">
    <h1 class="font--m-3 mb-2">대표자 정보</h1>
    <!-- 대표자 -->
    <FormValidationInput
      :inputValue.sync="form.name"
      :valid="{ name: '대표자', rules: 'required' }"
      title="대표자"
      placeholder="대표자 성함을 입력해주세요"
      autofocus
    />

    <!-- 주민등록번호 -->
    <FormValidationInput
      :inputValue.sync="form.rrn"
      :valid="{ name: '주민등록번호', rules: 'required|length:14' }"
      title="주민등록번호"
      type="tel"
      placeholder="주민등록번호를 입력해주세요"
      oninput="this.value = this.value.replace(/[^0-9]/g, '').substring(0, 13).replace(/^(\d{6})(\d{7})$/, '$1-$2')"
    />

    <!-- 핸드폰번호 -->
    <FormValidationInput
      :inputValue.sync="form.phone"
      :valid="{ name: '핸드폰번호', rules: 'required|min:12' }"
      title="핸드폰번호"
      type="tel"
      placeholder="핸드폰번호를 입력해주세요"
      oninput="this.value = this.value.replace(/[^0-9]/g, '').substring(0, 11).replace(/^(\d{3})(\d{3,4})(\d{4})$/, '$1-$2-$3')"
    />

    <!-- 이메일 -->
    <FormValidationInput
      :inputValue.sync="form.email"
      :valid="{ name: 'email', rules: 'required|email' }"
      title="이메일"
      placeholder="예) abd@gmail.com"
    />

    <ValidationProvider name="자택주소" rules="required" v-slot="{ errors }" slim>
      <div class="input-box">
        <p>자택주소</p>
        <v-layout align-center>
          <v-textarea
            v-if="!captureMode"
            v-model="form.home.adress"
            rows="2"
            hide-details
            outlined
            no-resize
            :error="!!errors[0]"
            auto-grow
          ></v-textarea>
          <div
            v-else
            class="capture-mode textarea"
            v-html="form.home.adress.replace(/\n/g, '<br>')"
          ></div>

          <v-radio-group
            v-model="form.home.isOwn"
            hide-details
            dense
            class="mt-0 pt-0"
            style="min-width: 95px"
          >
            <v-radio
              v-for="n in 2"
              :key="n"
              :label="n === 1 ? '자가' : '임차'"
              :value="n === 1 ? true : false"
              class="mb-0"
            ></v-radio>
          </v-radio-group>
        </v-layout>
        <v-slide-y-transition>
          <p v-if="errors.length > 0">{{ errors[0] }}</p>
        </v-slide-y-transition>
      </div>
    </ValidationProvider>

    <ValidationProvider name="실거주지 주소" rules="required" v-slot="{ errors }" slim>
      <div class="input-box">
        <p>실거주지 주소</p>
        <v-layout align-center>
          <v-textarea
            v-if="!captureMode"
            v-model="form.actualLiving.adress"
            rows="2"
            hide-details
            outlined
            no-resize
            :error="!!errors[0]"
            auto-grow
          ></v-textarea>
          <div
            v-else
            class="capture-mode textarea"
            v-html="form.actualLiving.adress.replace(/\n/g, '<br>')"
          ></div>

          <v-radio-group
            v-model="form.actualLiving.isOwn"
            hide-details
            dense
            class="mt-0 pt-0"
            style="min-width: 95px"
          >
            <v-radio
              v-for="n in 2"
              :key="n"
              :label="n === 1 ? '자가' : '임차'"
              :value="n === 1 ? true : false"
              class="mb-0"
            ></v-radio>
          </v-radio-group>
        </v-layout>
        <v-slide-y-transition>
          <p v-if="errors.length > 0">{{ errors[0] }}</p>
        </v-slide-y-transition>
      </div>
    </ValidationProvider>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  components: {
    FormValidationInput: () => import('@/components/common/form/FormValidationInput.vue'),
  },
  data() {
    return {
      form: {
        name: '',
        rrn: '',
        phone: '',
        email: '',
        // 자택
        home: {
          adress: '',
          isOwn: true,
        },
        // 실거주지
        actualLiving: {
          adress: '',
          isOwn: true,
        },
      },
    }
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapState('ui', ['captureMode']),
  },
  async created() {
    // 이름 세팅
    this.form.name = this.me.name
    // 핸드폰번호 세팅
    this.form.phone = this.me.phone
    // 이메일 세팅
    this.form.email = this.me.email
  },
}
</script>

<style lang="scss" scoped></style>
